/*
 * @Author: Wei Guojun 
 * @Date: 2021-06-01 16:37:23 
 * @Last Modified by: Wei Guojun
 * @Last Modified time: 2023-02-16 11:27:22
 */
import axios from 'axios';
import util from './util';
const requestPath = "/gateway/interface"
import Route from '../pages/home/router/router'
import WebSocketClass from './webSocketSave.js'
import store from "../pages/home/store/index";
/** axios 返回拦截器 */
axios.interceptors.response.use(response => {
  return response
}, error => {
  return Promise.resolve(error.response)
})
axios.defaults.timeout = 20000;
function loginOut(){
  try {
    WebSocketClass.close();
  } catch (error) {
   console.log(error+'websocket断开');
  }
  util.removeCookie('account_id')
  util.removeCookie('websocket_token')
  util.removeCookie('token')
  Route.push({path: '/login'})
}
function checkStatus(response) { // loading
  if(response && response.status === 401){
    loginOut()
    return 
  }
  if(response && response.status === 408){
    return {
      status: '错误',
      msg: '请求超时，请稍后再试~'
    }
  }
  // 如果http状态码正常，则直接返回数据
  if (response && (response.status === 200 || response.status === 304 || response.status === 400)) {
    return response.data
  }
  return {
    status: '错误',
    msg: '网络波动，请稍后再试'
  }
}

class Request {
  /** post请求 */
  post(self,data,headers) {
    return new Promise((resolve, reject) => {
      axios({
        url: requestPath,
        method: "post",
        responseType: 'json',
        headers: headers || {
          'content-type': 'application/json',

        },
        data: {
          "action": data.action,
          "option": data.option||'',
          "appid": util.jgEnv()=='pro' ? 'e5x5euo254nqa864' : 'eqpgm5ojnqm5h5gw',
          "token": util.getCookie('token'),
          "userId": util.getCookie('account_id'),
          "data": data.data || {},
          "req_time": new Date().getTime(),
          "appversion":"V1.5.5",
          "version": "V1.0",
          "noasync":data.noasync || ''
        }
      }).then(res => {
        if (checkStatus(res).success) {
            if(res.status === 200 && res.data.body.code == 401){
              loginOut()
            }else{
              resolve(checkStatus(res))
            }
        } else {
          if (checkStatus(res).errorcode == 'TOKEN_EXPIRED') {
              loginOut()
              return;
          }
          this.codeStatus(self)
        }
      }).catch(err => {
        this.codeStatus(self)
        self.$message.error(checkStatus(err).msg);
      })
    });
  }
  /** 上传文件 */
  fileAxios(self,data,url) {
    return new Promise((resolve, reject) => {
      axios({
        headers: {
          'content-type': 'content-type=multipart/form-data'
        },
        headers: {
          'content-type': 'application/json',
        },
        url: url,
        method: "post",
        data: data
      }).then(res => {
        if (checkStatus(res).result) {
          resolve(checkStatus(res))
        } else {
          this.codeStatus(self)
          self.$message.error(checkStatus(res).message);
        }
      }).catch(err => {
        self.$message.error(checkStatus(err).msg);
        this.codeStatus(self)
      })
    });
  }

  /** 下载 */
  download(self,data){
    return new Promise((resolve, reject) => {
      axios({
        headers:{
          'filename':'utf-8',
          'content-type': 'application/json',
          'account-type': 'ydgj_wechat'
        },
        url: data.action,
        method: "post",
        responseType:'blob',
        data:{
          "action":data.action,
          "appid": "bqczso63lyxl3h82",
          "token": util.getCookie('token'),
          "userId": util.getCookie('account_id'),
          "data": data.data || {},
          "req_time": new Date().getTime(),
          "version": "V1.0"
        }
      }).then(res => {
        if(res.status == 200){
          let fileName = res.headers['content-disposition'].split('=')[1]  // 获取文件名
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            let objectUrl = new Blob([res.data],{type: 'application/ms-excel;charset=utf-8'})
            // 兼容IE模式
            window.navigator.msSaveOrOpenBlob(objectUrl, fileName);
          }else{
            let objectUrl = URL.createObjectURL(new Blob([res.data]),{type: 'application/ms-excel;charset=utf-8'})
            // 文件地址
            const link = document.createElement('a')
            link.download = fileName
            link.setAttribute('download', fileName);
            link.href = objectUrl 
            document.body.appendChild(link);
            link.click() //点击下载
            document.body.removeChild(link); //下载完成移除元素
            window.URL.revokeObjectURL(objectUrl); //释放掉blob对象
          }
          resolve({success:true})
        }else{
          self.$message.error('导出失败，请重试！~');
        }
      }).catch(err => {
        self.$message.error(checkStatus(err).msg);
        this.codeStatus(self)
      })
    });
  }

  /** 处理状态 */
  codeStatus(self){
    if(self){
      self.isUp = false
      self.save_btn = false
      self.isSearch = false
      if(self.ruleForm && JSON.stringify(self.ruleForm) != "{}"){
        self.ruleForm.send.isAnalysis = false
        self.ruleForm.collect.isAnalysis = false
        self.first_click = true
      }
    }
  }

  //总线接口的处理
  getBusparameters(busArr){
    let busQuery = busArr.map(el=>{
      return{
        "appid": util.jgEnv()=='pro' ? 'e5x5euo254nqa864' : 'eqpgm5ojnqm5h5gw',
        "token": util.getCookie('token'),
        "userId": util.getCookie('account_id'),
        "action": el.action,
        "version": "V1.0",
        "appversion":"V1.6.1",
        "req_time": new Date().getTime(),
        "data": el.data
      }
    })
    return busQuery
  }
}
export default new Request()